export default "__VITE_ASSET__24f4def1__"